import React, { PureComponent } from 'react';
import { AutoCompleteResult } from './AutocompleteResults';

type Props = {
  suggestion: AutoCompleteResult;
  className?: string;
};

class AutocompleteIcon extends PureComponent<Props> {
  render() {
    const {
      className,
      suggestion: { fullDoc, icon },
    } = this.props;

    if (icon) return icon;

    const docType = fullDoc?.type;
    if (docType === 'provider-type' || docType === 'free-text' || docType === 'keyword') {
      return (
        <img
          alt="provider type"
          className={className}
          src="/images/icons/universal_search/uc.svg"
        />
      );
    }

    return null;
  }
}

export default AutocompleteIcon;
